export class BaseService {
    public numberIsFilled(value:any)
    {
        return value != '' && value > 0;
    }
    
    public numberIsValid(value:any)
    {
        return value != '' && value > 0;
    }
}